module.exports = __webpack_public_path__ + "media/flags/kp-5db0bfa7.svg";